import React from "react";

import { observer } from "mobx-react-lite";

import { ConfirmationModal } from "src/base-components/ConfirmationModal";
import { constructCommentDraftKey } from "src/comments/CommentEditor";
import { SplitNodeV2 } from "src/constants/NodeDataTypes";
import { NODE_TYPE } from "src/constants/NodeTypes";
import { useAuthoringContext } from "src/router/routerContextHooks";
import {
  SplitNodeDeletionModalContent,
  splitNodeDeletionDescription,
} from "src/splitNodeEditor/SplitNodeDeletionModalContent";
import { useGraphStore } from "src/store/StoreProvider";

const renderSimpleNodeContent = () => (
  <div className="font-inter-normal-12px text-gray-500">
    Are you sure you want to delete this Node?
    <br /> This action cannot be undone.
  </div>
);

export const DeleteNodeModal: React.FC = observer(() => {
  const {
    nodeToDelete,
    deleteNode,
    setIsDeleteNodeModalVisible,
    setNodeToDelete,
    nodes,
    setSelectedNode,
    isDeleteNodeModalVisible,
  } = useGraphStore();
  const { version } = useAuthoringContext();
  const onConfirmDelete = async () => {
    if (nodeToDelete) {
      const node = nodes.get(nodeToDelete);
      if (node) {
        try {
          await deleteNode(node, false);
          // Remove the associated current draft comments.
          const commentDraftPrefix = constructCommentDraftKey(
            version.id,
            node.id,
          );
          Object.keys(localStorage).forEach((key) => {
            if (key.startsWith(commentDraftPrefix)) {
              localStorage.removeItem(key);
            }
          });

          setIsDeleteNodeModalVisible(false);
          setNodeToDelete(null);
          setSelectedNode(undefined);
        } catch {
          setIsDeleteNodeModalVisible(false);
          setNodeToDelete(null);
        }
      }
    }
  };
  const isSplitNode =
    nodeToDelete && nodes.get(nodeToDelete)?.type === NODE_TYPE.SPLIT_NODE_V2;

  return (
    <ConfirmationModal
      children={
        isSplitNode && (
          <SplitNodeDeletionModalContent
            splitNode={nodes.get(nodeToDelete)! as SplitNodeV2}
          />
        )
      }
      confirmationButtonText="Yes, delete"
      description={
        isSplitNode ? splitNodeDeletionDescription : renderSimpleNodeContent()
      }
      open={isDeleteNodeModalVisible}
      title="Delete Node"
      onClose={() => setIsDeleteNodeModalVisible(false)}
      onConfirm={onConfirmDelete}
    ></ConfirmationModal>
  );
});
